import { endpoints } from '../constants/endpoints';
import { sendRequest } from './sendRequest';

// latestPullNotificationId is used for polling new notification

export function getNotificationsCountAndDataApi({ latestPullNotificationId, offset, limit, callType }) {
  const url = endpoints.notifications().index;
  const queryParams = { offset, limit };
  if (latestPullNotificationId) queryParams.latestPullNotificationId = latestPullNotificationId;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams,
  });
}

export function onOpenNotificationsActionApi() {
  const url = endpoints.notifications().action;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      type: 'OPEN',
    },
  });
}

export function onNotificationClickActionApi(notificationId) {
  const url = endpoints.notifications().action;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      type: 'CLICK',
      notificationId,
    },
  });
}

export const getHelloBarDetailsApi = ({ pageType }) =>
  sendRequest({
    url: endpoints.helloBar,
    credentials: 'include',
    queryParams: {
      page_type: pageType,
    },
  });

export const putHelloBarDetailsApi = ({ pageType }) =>
  sendRequest({
    url: endpoints.helloBar,
    credentials: 'include',
    method: 'PUT',
    queryParams: {
      page_type: pageType,
    },
  });
